define(function (require) {
    "use strict";

    var LE = require("app");

    var ContentGalleryFilters = [];

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentGalleryFilters = [
            {
                name: "statusBoolean",
                type: Marionette.GridView.FILTERS.TYPES.TOGGLE,

                getFilterData: function () {
                    return {
                        trueTitle: LE.translator.translate("LEContent.content.filter.status.true"),
                        falseTitle: LE.translator.translate("LEContent.content.filter.status.false")
                    };
                }
            },
            {
                name: "statusMultiple",
                type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

                getFilterData: function () {
                    var valuesArr = [];
                    valuesArr.push({id: "enabled", value: LE.translator.translate("LEContent.content.filter.status.true")});
                    valuesArr.push({id: "disabled", value: LE.translator.translate("LEContent.content.filter.status.false")});
                    valuesArr.push({id: "multiple", value: LE.translator.translate("LEContent.content.filter.status.multiple")});
                    return {
                        valuesArr: valuesArr,
                        placeholderText: LE.translator.translate("LEContent.content.filter.status.placeholder")
                    };
                }
            },
            {
                name: "categories",
                type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

                getFilterData: function () {
                    var categoriesCollection = LE.crossModule("manager", LE.media.actions.request, LE.mediaCodes.manager.reqres.getCategories);
                    var valuesArr = [];

                    categoriesCollection.each(function(categoryModel) {
                        valuesArr.push({id: categoryModel.id, value: categoryModel.get("name")});
                    });

                    return {
                        valuesArr: valuesArr,
                        placeholderText: LE.translator.translate("LEContent.content.filter.categories.placeholder")
                    };
                }
            },
            {
                name: "lobs",
                type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

                getFilterData: function (options) {
                    var gridModel = options.gridModel;
                    var allowedLobs = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getAllowedLobs);
                    var isAllLobsAllowedForUser = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.isAllLobsAllowedForUser);

                    var valuesArr = [];

                    _.each(allowedLobs, function (lobModel) {
                        valuesArr.push({id: lobModel.id, value: lobModel.getName()});
                    });

                    if (isAllLobsAllowedForUser) {
                        valuesArr.push({id: gridModel.NO_LOBS_VALUE, value:LE.translator.translate("LEContent.content.filter.lobs.unassigned")});
                    }


                    return {valuesArr: valuesArr, placeholderText: LE.translator.translate("LEContent.content.filter.lobs.placeholder")};
                }
            },
            {
                name: "skills",
                type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

                getFilterData: function () {
                    var skillsCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getSkillsCollection);
                    var valuesArr = [];

                    skillsCollection.each(function(skillModel) {
                        valuesArr.push({id: skillModel.id, value: skillModel.get("name")});
                    });

                    return {
                        valuesArr: valuesArr,
                        placeholderText: LE.translator.translate("LEContent.content.filter.skills.placeholder")
                    };
                }
            },
            {
                name: "languages",
                type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

                getFilterData: function () {
                    var languageCodesArr = LE.siteSettings.supportedLanguageSettings.getSupportedLanguageCodes();
                    var valuesArr = [];

                    _.each(languageCodesArr, function (langCode) {
                        valuesArr.push({id: langCode, value: LE.translator.translate("LEFramework.account.lang." + langCode + ".name")});
                    }, this);

                    return {valuesArr: valuesArr, placeholderText: LE.translator.translate("LEContent.content.filter.languages.placeholder")};
                }
            }
        ];
    });

    return ContentGalleryFilters;
});
